import React from "react";

export default function LocationMap() {
    return (
        <div className="max-w-4xl mx-auto my-8">
            <h2 className="text-2xl font-bold mb-4">Hier finden Sie uns</h2>
            <div className="w-full h-96">
                <iframe
                    title="Werkstatt Standort"
                    src={
                        "https://maps.google.com/maps?q=Autoservice%20Gro%C3%9F%20GmbH,%20Tannenkircher%20Stra%C3%9Fe%202a,%2079415%20Bad%20Bellingen" +
                        "&z=15&output=embed"
                    }
                    className="w-full h-full border-0"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
        </div>
    );
}
